// shared/services/feature-flag.service.ts
import { Injectable, signal, WritableSignal } from '@angular/core';
import { OVERRIDE_LIST_KEY, OVERRIDE_TOGGLE_KEY } from 'shared/constants/general-constants';
import { FeatureFlags } from 'shared/interfaces/environment.interface';
import { ensureOverrideListExists, getMergedFeatureFlags } from 'shared/util/feature-flag.utils';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
    public featureFlags: WritableSignal<FeatureFlags>;

    constructor(private readonly storage: StorageService) {
        ensureOverrideListExists();
        this.featureFlags = signal<FeatureFlags>(getMergedFeatureFlags());

        this.storage.localChanges.subscribe(({ key: changedKey }) => {
            if (changedKey === OVERRIDE_TOGGLE_KEY || changedKey === OVERRIDE_LIST_KEY) {
                ensureOverrideListExists();
                this.featureFlags.set(getMergedFeatureFlags());
            }
        });
    }
}
